module.exports = __webpack_public_path__ + "static/media/skpservices.89b62f53.PNG";